export const navigate = (history, url) => history?.push(url);

export const goBackHome = history => history?.push('/');
